import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../redux/features/auth/authSlice";
import bannerReducer from "../redux/features/banner/bannerSlice";
import lotteryReducer from "../redux/features/lotteryBrand/lotteryBrandSlice";
import lotteryBrandDayReducer from "../redux/features/lotteryBrandDay/lotteryBrandDaySlice";
import bulkRegistrationReducer from "../redux/features/bulkRegistration/bulkRegistrationSlice";
import ticketReducer from "../redux/features/tickets/ticketSlice";
import lotteryTicketReducer from "../redux/features/lottery/lotterySlice";
import winnersReducer from "../redux/features/winners/winnersSlice";
import inquiriesReducer from "../redux/features/inquiries/inquiriesSlice";
import dashboardReducer from "../redux/features/dashboard/dashboardSlice";
import paymentReducer from "../redux/features/payments/paymentSlice";
import ticketReportreducer from "../redux/features/ticketReports/ticketReportsSlice";
import userReducer from "../redux/features/users/userSlice";
import staffReducer from "../redux/features/staff/staffSlice";
import resultReducer from "../redux/features/results/resultSlice";
import withdrawalReducer from "../redux/features/withdrawals/withdrawalsSlice";
import optionReducer from "../redux/features/options/optionSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    banner: bannerReducer,
    lottery: lotteryReducer,
    lotteryBrandDay: lotteryBrandDayReducer,
    bulkRegistration: bulkRegistrationReducer,
    ticket: ticketReducer,
    lotteryTicket: lotteryTicketReducer,
    winner: winnersReducer,
    inquiry: inquiriesReducer,
    dashboard: dashboardReducer,
    payment: paymentReducer,
    ticketReport: ticketReportreducer,
    user: userReducer,
    staff:staffReducer,
    result: resultReducer,
    withdrawal: withdrawalReducer,
    option: optionReducer,
  },
});

export default store;
